// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"776bb2cd","160":"e03c9364","906":"f7134081"}[chunkId] + ".css";
};